{
  "fields": {
    "email": "البريد الإلكتروني",
    "password": "كلمة المرور"
  },
  "errors": {
    "emailRequired": "البريد مطلوب",
    "emailInvalid": "بريد إلكتروني غير صالح",
    "passwordRequired": "كلمة المرور مطلوبة",
    "invalidCredentials": "البريد أو كلمة المرور غير صحيحة",
    "captchaFailed": "فشل التحقق، حاول مرة أخرى",
    "locked": "تم قفل الحساب مؤقتاً، حاول بعد {{minutes}} دقيقة",
    "disabled": "الحساب موقوف، تواصل مع الإدارة"
  },
  "login": {
    "title": "تسجيل الدخول",
    "intro": "للملاك ومنسقي الحجوزات. سيتم توجيهك للوحة المناسبة لحسابك.",
    "expired": "انتهت الجلسة، سجّل الدخول مجدداً.",
    "resetDone": "تم تعيين كلمة المرور، يمكنك تسجيل الدخول الآن.",
    "forgot": "نسيت كلمة المرور؟",
    "submit": "دخول",
    "submitting": "جاري الدخول…",
    "lockHint": "بعد 5 محاولات خاطئة يُقفل الحساب مؤقتاً لمدة 15 دقيقة."
  },
  "forgot": {
    "title": "نسيت كلمة المرور",
    "intro": "أدخل بريدك وسنرسل لك رابطاً لإعادة تعيين كلمة المرور.",
    "done": "إذا كان البريد مسجلاً ستصلك رسالة تحتوي على رابط إعادة التعيين خلال دقائق. الرابط صالح لمدة ساعة.",
    "submit": "إرسال الرابط",
    "backToLogin": "العودة لتسجيل الدخول"
  },
  "setPassword": {
    "titleInvite": "تعيين كلمة المرور",
    "titleReset": "إعادة تعيين كلمة المرور",
    "invalidLink": "الرابط غير صالح أو منتهي الصلاحية. اطلب رابطاً جديداً.",
    "requestNew": "طلب رابط جديد",
    "greeting": "مرحباً {{name}}، اختر كلمة مرور لحساب <email>{{email}}</email>.",
    "newPassword": "كلمة المرور الجديدة",
    "hint": "10 أحرف على الأقل، وتحتوي على حرف ورقم",
    "strengthLabel": "قوة كلمة المرور: {{level}}",
    "strength": {
      "weak": "ضعيفة",
      "medium": "متوسطة",
      "strong": "قوية"
    },
    "confirm": "تأكيد كلمة المرور",
    "submit": "حفظ كلمة المرور",
    "errors": {
      "min": "10 أحرف على الأقل",
      "letter": "يجب أن تحتوي على حرف",
      "digit": "يجب أن تحتوي على رقم",
      "mismatch": "كلمتا المرور غير متطابقتين"
    },
    "contractSigned": "تم توقيع العقد بنجاح وستصلك نسخة PDF على بريدك. أكمل التسجيل باختيار كلمة المرور."
  }
}
